import { getListingProfileTitle } from '../RentalPortalListingProfile.utils'

import { LISTING_PROFILE_DOCUMENTS_BREADCRUMB_LISTING } from './RentalPortalListingProfileDocuments.constants'

export function getListingProfileDocumentsRootBreadcrumbs({ listingData, t }) {
  return [
    {
      id: LISTING_PROFILE_DOCUMENTS_BREADCRUMB_LISTING,
      title: getListingProfileTitle({ listingData, t }),
    },
  ]
}
